<template>
  <div class="home-box">
    <SummaryLeads v-model:value="dataSummary" />
    <a-row :gutter="16">
      <a-col :span="12">
        <LeadDeliveryEchart title="线索投放情况" />
      </a-col>
      <a-col :span="12">
        <LeadConversion title="线索转化" v-model:value="dataSummary" :spinning="spinning" />
      </a-col>
      <a-col :span="12">
        <RegionDistributionChart title="客户区域分布" v-model:value="dataSummary" :spinning="spinning" />
      </a-col>
      <a-col :span="12">
        <InvalidReasonEchart title="无效原因分析" />
      </a-col>
    </a-row>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, inject } from 'vue'
import SummaryLeads from './components/SummaryLeads.vue'
import LeadDeliveryEchart from './components/LeadDeliveryEchart.vue'
import LeadConversion from './components/LeadConversion.vue'
import RegionDistributionChart from './components/RegionDistributionEchart.vue'
import InvalidReasonEchart from './components/InvalidReasonEchart.vue'
import { zbuGetDataSummary } from '@/api/marketing/index'
enum Subdomain {
  Fbu = 'fbu',
  Lbu = 'lbu'
}
const subdomain = inject<Subdomain>('subdomain') || Subdomain.Fbu

const spinning = ref(false)
const dataSummary = ref<any>({})
const getSummaryData = () => {
  spinning.value = true
  zbuGetDataSummary()
    .then((res: any) => {
      if (subdomain === Subdomain.Lbu) {
        res.data.transVos = res.data.transVos.filter((item: any) => item.clueType !== 5)
      }
      dataSummary.value = res.data
    })
    .catch(() => {
      dataSummary.value = {}
    })
    .finally(() => {
      spinning.value = false
    })
}

onBeforeMount(getSummaryData)
</script>
<style lang="scss" scoped>
.home-box {
  background: rgb(249, 249, 255);
  padding: 20px 30px;
}
</style>
